import { InputField } from '@/components/Auth/Buttons';
import { OrgUserContext } from '@/components/OrgUsers/OrgUserContext';
import { useContext, useState } from 'react';
import { createUserAPI } from '@/utils/utils';
import { OrgContext } from '@/components/Organizations/OrgContext';
import { Banner, SignupBanner } from '@/components/Banner';

type InviteInputState = {
  email: string;
  firstName: string;
  lastName: string;
};

// Main component
export default function Invite() {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [inviteMail, setInviteMail] = useState('');
  const [error, setError] = useState('');
  const [inviteInput, setInviteInput] = useState<InviteInputState>({
    email: '',
    firstName: '',
    lastName: ''
  });

  // Remove this code please! This is horrible practice ~Kyle.
  const { setQueryOrgs } = useContext(OrgContext);
  const { setGqlQueryOrgs, currentOrganization, currentOrgUsers } = useContext(OrgUserContext);

  const activeHosts = currentOrgUsers.filter(
    (cUser) => cUser.accountStatus !== 'DELETED' && cUser.role === 'HOST'
  ).length;
  const canAddUser = activeHosts < currentOrganization.numHost;

  const updateInviteInput = (field: string, value: string) => {
    setInviteMail('');
    setError('');
    setInviteInput((prevInput) => ({
      ...prevInput,
      [field]: value
    }));
  };

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      if (!isFormValid()) {
        setError('Please fill out all fields');
        return;
      }

      if (currentOrganization?.emailDomains) {
        const emailDomain = inviteInput.email.split('@')[1];
        if (!currentOrganization.emailDomains.includes(emailDomain)) {
          setError('Email domain must belong to one of the organization domains');
          return;
        }
      }

      const normalizedEmail = inviteInput.email.trim().toLowerCase();
      await createUserAPI(
        currentOrganization.id,
        inviteInput.firstName,
        inviteInput.lastName,
        normalizedEmail,
        false
      );
      setInviteMail(normalizedEmail);
      setInviteInput({
        email: '',
        firstName: '',
        lastName: ''
      });
      setQueryOrgs(true);
      setGqlQueryOrgs(true);
    } catch (err: any) {
      console.log('Error in Invite User Flow', err);
      const message = err?.message || 'Unable to invite user';
      setError(message);
    } finally {
      setIsLoading(false);
    }
  };

  const isFormValid = () => {
    return inviteInput.firstName !== '' && inviteInput.lastName !== '' && inviteInput.email !== '';
  };

  return (
    <>
      <div className="py-32 px-100 bg-white z-100 rounded-xs relative w-608 m-auto">
        <div className="border-b border-secondary-midnight-100">
          <h2 className="text-h2 text-center mb-4">Invite Teammates</h2>
          <p className="text-body text-neutral-400 text-center mb-24">
            Add the people who will create and host games
          </p>
          <form className="space-y-12">
            <Banner
              title={'Invitation succesfully sent'}
              body={
                <>
                  <span className="underline">{inviteMail}</span> will receive invitation to join.
                  Once it&apos;s accepted the user can start working with Scribl
                </>
              }
              variant={'success'}
              visible={!!inviteMail}
            />
            {error && (
              <div className="mb-24">
                <SignupBanner text={error ?? ''} variant={'error'} visible={!!error} />
              </div>
            )}
            <InputField
              disabled={!canAddUser}
              label="First Name"
              value={inviteInput.firstName}
              onChange={(e) => updateInviteInput('firstName', e.target.value)}
            />
            <InputField
              disabled={!canAddUser}
              label="Last Name"
              value={inviteInput.lastName}
              onChange={(e) => updateInviteInput('lastName', e.target.value)}
            />
            <InputField
              disabled={!canAddUser}
              label="Email Address"
              value={inviteInput.email}
              onChange={(e) => updateInviteInput('email', e.target.value)}
            />
            <button
              className="btn btn-primary mt-12 mb-24 w-full"
              disabled={isLoading || !canAddUser}
              onClick={onSubmit}
            >
              Send Invitation
            </button>
          </form>
        </div>
        <p className="text-h4 text-center mt-24">
          Licenses Used: {activeHosts} of {currentOrganization.numHost}
        </p>
      </div>
    </>
  );
}
